import { SourceType } from "./SourceType";

export const SourceMappingType = {
    [SourceType.DISPRZ] : "Disprz",
    [SourceType.NICE_FRAMEWORK]: "NICE Framework",
    [SourceType.SFIA_V7]: "SFIA v7",
    [SourceType.SINGAPORE_SKILLS_FUTURE]: "Singapore Skills Future",
    [SourceType.DISPRZ_ATOMIC_SKILLS]: "Disprz Atomic Skills Model"
  };